import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer } from '../hooks/useScrollAnimation';
import { Shield, ShieldCheck, Lock } from 'lucide-react';
function ComplianceBadge({
  label
}: {
  label: string;
}) {
  return <motion.div variants={fadeInUp} className="flex items-center gap-3 bg-dark-card border border-dark-border p-4 rounded-lg hover:border-gold/50 transition-colors" data-id="element-159">
      <ShieldCheck className="w-5 h-5 text-gold" data-id="element-160" />
      <div data-id="element-161">
        <div className="text-white font-bold text-sm" data-id="element-162">{label}</div>
        <div className="text-xs text-gold uppercase tracking-wider font-mono" data-id="element-163">
          Certified
        </div>
      </div>
    </motion.div>;
}
export function CybersecuritySection() {
  return <section id="cybersecurity" className="py-20 bg-dark-bg relative overflow-hidden" data-id="element-164">
      {/* Background Icon */}
      <div className="absolute right-[-10%] top-1/2 transform -translate-y-1/2 opacity-[0.03] pointer-events-none" data-id="element-165">
        <Shield className="w-[500px] h-[500px] text-cyan" data-id="element-166" />
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10" data-id="element-167">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={staggerContainer} data-id="element-168">
          <div className="flex flex-col md:flex-row gap-12 items-center mb-16" data-id="element-169">
            <motion.div variants={fadeInUp} className="flex-1" data-id="element-170">
              <span className="font-sans text-gold/80 tracking-widest uppercase text-xs font-semibold mb-2 block" data-id="element-171">
                Security & Compliance
              </span>
              <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-172">
                Zero-Trust Security Leadership
              </h2>
              <p className="text-gray-400 text-lg leading-relaxed" data-id="element-173">
                Pioneering security-first engineering cultures. Integrating
                compliance into the SDLC to ensure speed without compromising
                safety.
              </p>
            </motion.div>

            <motion.div variants={fadeInUp} className="flex-1 grid grid-cols-2 gap-4 w-full" data-id="element-174">
              <div className="bg-dark-elevated p-6 rounded-xl text-center border border-dark-border" data-id="element-175">
                <div className="text-3xl font-mono font-bold text-white mb-1" data-id="element-176">
                  0
                </div>
                <div className="text-xs text-gray-400 uppercase" data-id="element-177">
                  Breaches (6 Years)
                </div>
              </div>
              <div className="bg-dark-elevated p-6 rounded-xl text-center border border-dark-border" data-id="element-178">
                <div className="text-3xl font-mono font-bold text-white mb-1" data-id="element-179">
                  100%
                </div>
                <div className="text-xs text-gray-400 uppercase" data-id="element-180">
                  Audit Pass Rate
                </div>
              </div>
            </motion.div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4" data-id="element-181">
            <ComplianceBadge label="SOC 2 Type II" data-id="element-182" />
            <ComplianceBadge label="ISO 27001" data-id="element-183" />
            <ComplianceBadge label="NIST CSF" data-id="element-184" />
            <ComplianceBadge label="PCI DSS Level 1" data-id="element-185" />
            <ComplianceBadge label="HIPAA / HITECH" data-id="element-186" />
            <ComplianceBadge label="FedRAMP High" data-id="element-187" />
          </div>
        </motion.div>
      </div>
    </section>;
}